import { createFileRoute } from '@tanstack/react-router'
import JobApplicationFormPage from '../pages/JobApplicationFormPage'

export const Route = createFileRoute('/')({
  component: JobApplicationFormPage,
})
